import 'ol/ol.css'
import { useGeographic } from 'ol/proj';
useGeographic(); // Tell OL to expect [Lon, Lat] globally
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM'

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Icon, Style } from 'ol/style';

import iconImage from '../img/MarkerPin.png';

import Overlay from 'ol/Overlay.js';

//console.log("loading map");
var createMap = function (mapInstance, longitude, latitude, mapTitle, mapZoom) {
    const map = new Map({
        target: mapInstance,
        layers: [
            new TileLayer({
                source: new OSM()
            })

        ],
        view: new View({
            center: [longitude, latitude],
            zoom: mapZoom
        })
    });

    const marker = new Feature({
        geometry: new Point([longitude, latitude])
    });

    const markerStyle = new Style({
        image: new Icon({
            anchor: [0.5, 1], // This ensures the tip of the pin is at the coordinate
            height: 40, // another method is "scale" - size relative to original image eg 1 or .5
            src: iconImage
        }),
    });

    marker.setStyle(markerStyle);

    const vectorSource = new VectorSource({
        features: [marker],
    });

    const vectorLayer = new VectorLayer({
        source: vectorSource,
        visible: true
    });

    map.addLayer(vectorLayer);

    const infoWindow = mapInstance.querySelector('.infoWindow');
    const infoWindowContent = mapInstance.querySelector('.infoWindowContent');
    const infoWindowCloser = mapInstance.querySelector('.infoWindowCloser');
    infoWindowContent.innerHTML = "<p>" + mapTitle + "</p>";

    const infoWindowOverlay = new Overlay({
        element: infoWindow
    });

    map.addOverlay(infoWindowOverlay);
    infoWindowOverlay.setPosition([longitude, latitude]);

    map.on("click", function (event) {
        var feature = map.forEachFeatureAtPixel(event.pixel,
            function (feature) {
                return feature;
            });
        if (feature === marker) {
            infoWindowOverlay.setPosition([longitude, latitude]);
        }
    });

    infoWindowCloser.onclick = function () {
        infoWindowOverlay.setPosition(undefined);
        return false;
    };

}

document.querySelectorAll(".openStreetMap").forEach(function (mapInstance) {
    const longitude = parseFloat(mapInstance.dataset.longitude);
    const latitude = parseFloat(mapInstance.dataset.latitude);
    const mapTitle = mapInstance.dataset.maptitle;
    const zoom = mapInstance.dataset.zoom;
    createMap(mapInstance, longitude, latitude, mapTitle, zoom);
});




